import { env } from '../env';
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Skeleton, Typography } from "@mui/material";
import PlaceCard from "../component/PlaceCard";
import { useState } from "react";

export default function Place({ setPage, page }) {
  const [places, setPlaces] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
        mode: "cors",
        body: JSON.stringify({
            LK: env.REACT_APP_LICENCE_KEY,
            ENVID: env.REACT_APP_ENV_ID,
        })
    };
    fetch(`${env.REACT_APP_PROXY_BASE_URL}/place`, request)
      .then((res) => res.json())
      .then((res) => {
        setPlaces(res.Lieux);
      })
      .catch((err) => console.log("Places fetch error " + err))
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return (
    <Box mt={5}>
      <Grid container item justifyContent="center" mb={5}>
              {places === undefined || places != null ? (
                  <Typography align="center" variant="h3">
                      Choisissez un lieu
                  </Typography>
              ) : (
                <Typography align="center" variant="h3">
                                 
                </Typography>
              )}
      </Grid>
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        {places === undefined ? (
          <Grid item>
            <Skeleton
              ariant="rectangular"
              width={360}
              height={160}
              animation="wave"
              key="sk1"
                      />
          </Grid>
              ) : (
                  places != null ?
          places?.map((data) => (
            <Grid key={data.ID} item>
              <PlaceCard setPage={setPage} page={page} data={data} />
            </Grid>
          )) : (<Typography align="center" variant="h3">
              Lieux non disponibles
          </Typography>)
        )}
      </Grid>
    </Box>
  );
}
